export default __webpack_public_path__ + "static/media/image_02.e78503a6.png";